import gql from 'graphql-tag'

export const receiveBirthdayPresent = gql`
  mutation birthdayPresent($patientId: ID!) {
    birthdayPresent(patientId:$patientId)
  }
`


// WEBPACK FOOTER //
// ./src/modules/birthday/actions/mutation.js